import React from "react"
import types from "prop-types"
import Rails from "@rails/ujs"
import { useSelector } from "react-redux"
import {
  isMissingRequiredTaskReportBuilderData,
  name,
  orderedColumns,
  selectedCategorySlug,
  selectedTaskFormSlug,
  shared,
} from "reduxSlices/taskReportBuilderSlice"
import {
  ACTIVITY_HUB_FORM_SUBMISSION_REPORTS_PATH,
  ACTIVITY_HUB_TASK_REPORTS_PATH,
  redirectTo,
  taskReportPath,
} from "utils/routeHelpers"
import { HiddenInput } from "shared/inputs"
import { PrimaryButton, SecondaryButton } from "shared/buttons"

const cancel = () => {
  redirectTo(ACTIVITY_HUB_FORM_SUBMISSION_REPORTS_PATH)
}

const TaskReportBuilderActions = ({ reportId = null }) => {
  const reportName = useSelector(name)
  const sharedFlag = useSelector(shared)
  const categorySlug = useSelector(selectedCategorySlug)
  const taskFormSlug = useSelector(selectedTaskFormSlug)
  const columns = useSelector(orderedColumns)
  const disabled = useSelector(isMissingRequiredTaskReportBuilderData)

  const action = reportId ? taskReportPath(reportId) : ACTIVITY_HUB_TASK_REPORTS_PATH

  return (
    <form action={action} method="post" className="mt-6">
      <HiddenInput name="authenticity_token" value={Rails.csrfToken()} />
      {
        reportId && (
          <HiddenInput name="_method" value="put" />
        )
      }
      <HiddenInput name="report[name]" value={reportName} />
      <HiddenInput name="report[shared]" value={sharedFlag.toString()} />
      <HiddenInput name="report[task_report_setting_attributes][category_slug]" value={categorySlug} />
      <HiddenInput name="report[task_report_setting_attributes][task_form_slug]" value={taskFormSlug} />
      {
        columns.flatMap(({ id, type }) => (
          [
            <HiddenInput
              key={`column-key-${type}-${id}`}
              name="report[task_report_setting_attributes][columns][][key]"
              value={id}
            />,
            <HiddenInput
              key={`column-type-${type}-${id}`}
              name="report[task_report_setting_attributes][columns][][type]"
              value={type}
            />,
          ]
        ))
      }
      <div className="flex justify-center">
        <SecondaryButton
          className="mr-4"
          onClick={cancel}
          text="Cancel"
        />
        <PrimaryButton
          disabled={disabled}
          text="Save"
          type="submit"
        />
      </div>
    </form>
  )
}

TaskReportBuilderActions.propTypes = {
  reportId: types.number,
}

export default TaskReportBuilderActions
